<template>
  <div class="value-slider-wrapper">
    <slider class="value-slider"
            ref="slider"
            :options="sliderOptions"
            @slide="handleSlide"
            @tap="handleTap">
      <slideritem v-for="(slide,index) in slides"
                  :key="index"
                  v-html="buildSlideTemplate(slide)"/>
    </slider>
  </div>
</template>

<script>
import { slider, slideritem } from 'vue-concise-slider';

const slides = [
  {
    title: 'Integrity',
    text: 'Do the right thing, always.'
  },
  {
    title: 'Responsiveness',
    text: 'Act promptly and decisively, anchored by deep knowledge and careful listening.'
  },
  {
    title: 'Collaboration',
    text: 'Work enthusiastically with others and be open to different perspectives.'
  },
  {
    title: 'Service',
    text: 'Commit to helping our policyholders, team members, and community.'
  },
  {
    title: 'Innovation',
    text: 'Continually seek better solutions while anticipating future needs.'
  },
  {
    title: 'Stewardship',
    text: 'Take good care of the resources entrusted to us.'
  }
];

const sliderOptions = {
  currentPage: 0,
  direction: 'vertical',
  speed: 1000
};

export default {
  name: 'ValuesSlider',
  components: {
    slider,
    slideritem
  },
  data: function () {
    return {
      slides: slides,
      sliderOptions: sliderOptions,
      autoplayTimer: null,
      disableAutoplay: false,
      lastPage: null
    };
  },
  mounted () {
    if (!this.disableAutoplay) this.initAutoplay();
  },
  beforeDestroy () {
    this.stopAutoplay();
  },
  methods: {
    initAutoplay: function () {
      if (!this.$refs.slider) return;
      this.autoplayTimer = setInterval(() => {
        if (!this.$refs.slider) return;
        if (this.lastPage === slides.length - 1) {
          this.$refs.slider.$emit('slideTo', 0);
          return;
        }
        this.$refs.slider.$emit('slideNext');
      }, 4000);
    },
    stopAutoplay: function () {
      if (this.autoplayTimer) clearInterval(this.autoplayTimer);
    },
    resetAutoplay: function () {
      this.stopAutoplay();
      this.initAutoplay();
    },
    buildSlideTemplate: function (slide) {
      const videoId = slide.title.toLowerCase();
      const videoSource = require(`../../assets/values-${videoId}.gif`);
      return `
        <div class="value-slider__slide grid-x">
          <div class="value-slider__slide-left cell small-6">
            <img class="value-slider__video value-slider__video_${videoId}"
                 src="${videoSource}"
                 alt="${videoId}"/>
          </div>
          <div class="value-slider__slide-right cell small-6">
            <div class="value-slider__text-group">
              <h2>${slide.title}</h2>
              <p>${slide.text}</p>
            </div>
          </div>
        </div>
      `;
    },
    handleTap: function () {
      if ((!this.disableAutoplay)) this.resetAutoplay();
    },
    handleSlide: function (data) {
      if (data.currentPage > slides.length - 1) return;
      if (data.currentPage === this.lastPage) {
        this.handleTap();
        return;
      }

      /* eslint-disable */
      const sliderVideos = $(".value-slider__video");
      sliderVideos.hide();

      const currentSliderVideo = sliderVideos.eq(data.currentPage);
      let src = currentSliderVideo.attr('src');
      const queryIndex = src.indexOf('?');

      if (queryIndex !== -1) src = src.slice(0, queryIndex);

      currentSliderVideo.attr('src', src + '?' + Math.random());
      currentSliderVideo.show();
      /* eslint-enable */
      this.lastPage = data.currentPage;
    }
  }
};
</script>
